import React, { useState } from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";

type AudioRecordingProps = {
  item: {
    id: number;
    name: string;
  };
};

export const AudioRecording: React.FC<AudioRecordingProps> = ({ item }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [recordingComplete, setRecordingComplete] = useState(false);

  // Simulate starting the recording
  const handleStartRecording = () => {
    setIsRecording(true);
    setRecordingComplete(false);
    
    // Simulate recording process with a timer
    setTimeout(() => {
      setIsRecording(false);
      setRecordingComplete(true);
    }, 3000);
  };

  const handlePlayback = () => {
    // In a real implementation, this would play the recorded audio
    console.log("Playing recorded audio");
  };

  const handleSubmit = () => {
    // In a real implementation, this would submit the recording
    console.log("Recording submitted");
    setRecordingComplete(false);
  };

  return (
    <ExerciseTypeContainer
      item={item as never}
      title1="Exercício de gravação de áudio"
      title2="Grave a seguinte frase:"
      subtitle="Por favor, fale com clareza próximo ao microfone"
      exerciseNumber={`exercício n. ${item.id}`}
      hideVerifyButton
    >
      <div className="mt-8">
        <div className="text-lg font-medium mb-4">
          "What time is it? It's half past seven."
        </div>
        
        <div className="flex items-center justify-center gap-4 mt-6">
          {!isRecording && !recordingComplete ? (
            <button
              onClick={handleStartRecording}
              className="px-4 py-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors flex items-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="10" r="5" />
              </svg>
              Iniciar Gravação
            </button>
          ) : isRecording ? (
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
              <span>Gravando...</span>
            </div>
          ) : (
            <div className="flex gap-3">
              <button
                onClick={handlePlayback}
                className="px-4 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
              >
                ▶️ Reproduzir
              </button>
              <button
                onClick={handleStartRecording}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-full hover:bg-gray-300 transition-colors"
              >
                🔄 Regravar
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors"
              >
                ✓ Enviar
              </button>
            </div>
          )}
        </div>
      </div>
    </ExerciseTypeContainer>
  );
}; 